module.exports = __webpack_public_path__ + "static/polar-extraimg2@2x-min-91c87355d0c49d3a7de8ca7072f8b9ee.png";